import '../constants/culture.js';
import { EMBEDDED_USER_AGENTS } from '../constants/userAgents.js';
import { useState, useEffect } from 'react';

const devices = {
  browser: 'browser',
  server: 'server',
  native: 'native'
};
const {
  browser,
  server,
  native
} = devices;
const canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
const canUseNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
const device = canUseNative ? native : canUseDOM ? browser : server;
const useDeviceInfo = () => {
  const [userAgent, setUserAgent] = useState('');
  const [isEmbeddedBrowser, setIsEmbeddedBrowser] = useState(false);
  useEffect(() => {
    setUserAgent(navigator.userAgent);
    setIsEmbeddedBrowser(Object.values(EMBEDDED_USER_AGENTS).some(ua => navigator.userAgent.includes(ua)));
  }, []);
  return {
    isBrowser: device === browser,
    isServer: device === server,
    isNative: device === native,
    isEmbeddedBrowser,
    device,
    userAgent
  };
};

export { useDeviceInfo };
